import React, { Component } from 'react';
import style from '../../style/style';
import LineChart from '../linechart';
import Loading from '../loading';
import Barchart from '../barchart';

class Crime extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    const data = { ...this.props };
    
    const crimeArr = []
    if (!isNaN(parseInt(data.data["2013"]))) {
      crimeArr.push({x: 0, y: parseInt(data.data["2013"])});
    }
    if (!isNaN(parseInt(data.data["2014"]))) {
      crimeArr.push({x: 1, y: parseInt(data.data["2014"])});
    }
    if (!isNaN(parseInt(data.data["2015"]))) {
      crimeArr.push({x: 2, y: parseInt(data.data["2015"])});
    }
    if (!isNaN(parseInt(data.data["2016"]))) {
      crimeArr.push({x: 3, y: parseInt(data.data["2016"])});
    }
    
    const currentCrimes = crimeArr[crimeArr.length -1];

    return (
      <div 
        style={{ ...style.fact.layout }}
      > 
        <div style={{ ...style.fact.left, paddingTop: "0.5rem" }}>
          <LineChart
            data = {crimeArr}
          />
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ ...style.fact.heading, marginBottom: 0 }}>
            { `${currentCrimes.y} crimes` }
          </h2>
          <p style={{ marginTop: 0 }}>{`Reported at the ${ data.data.Name } in 2016`}</p>
          <Barchart
              data={ data.data }
              fields={[
                { "name": "attempts to murder, assault, harass", "value": "3_2016" },
                { "name": "dangerous or negligent acts", "value": "4_2016" },
                { "name": "kidnappings", "value": "5_2016" },
                { "name": "robberies, extortion & hijacking", "value": "6_2016" },
                { "name": "burglaries", "value": "7_2016" },
                { "name": "thefts", "value": "8_2016" },
                { "name": "fraud offences", "value": "9_2016" },
                { "name": "drug offences", "value": "10_2016" },
                { "name": "weapons & explosives offences", "value": "11_2016" },
                { "name": "damage to property, environment", "value": "12_2016" },
                { "name": "public order offences", "value": "13_2016" },
                { "name": "organistation of crime, offences against government & justice procedures", "value": "15_2016" }
              ]}
              total={ "2016" }
            />
            <div style={{ ...style.fact.source }}>Source: Recorded crime 2016, <a href="http://www.cso.ie/px/pxeirestat/Statire/SelectVarVal/Define.asp?Maintable=CJA07&Planguage=0">CSO</a>.</div>
        </div>
      </div>);
  }
}

export default Crime;



// WEBPACK FOOTER //
// ./src/components/crime/index.js